export default __webpack_public_path__ + "static/media/python.d8b377f0.png";